import { useInfiniteQuery } from "@tanstack/react-query";
import { boronClient } from "../../api";
import { createError, HTTPErrors } from "../../errors";
import { getNextPageParam } from "../../helpers/ReactQueryHelper";
import { paths } from "../../lib/api/v1";

const path = "/api/v1/sections/multi_section_batch_histories";

type ResponseBody =
  paths[typeof path]["get"]["responses"]["200"]["content"]["application/json"];

type PageData = ResponseBody["multiSectionBatchHistories"];

export type MultiSectionBatchHistoryListItem = PageData["data"][number];

export const useMultiSectionBatchHistories = () => {
  const {
    data,
    isLoading,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    error,
  } = useInfiniteQuery<PageData, HTTPErrors>({
    queryKey: ["multiSectionBatchHistories", "list"],
    queryFn: async ({ pageParam }) => {
      const { response, data } = await boronClient.GET(path, {
        params: {
          query: {
            page: pageParam as number,
            per: 20,
          },
        },
      });

      if (response.ok && data) {
        return data.multiSectionBatchHistories;
      }

      throw await createError(response);
    },
    initialPageParam: 1,
    getNextPageParam,
  });

  const histories = data?.pages.flatMap((page) => page.data) ?? [];

  return {
    histories,
    isLoading,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    error,
  };
};
